import React from 'react';
import BrandDropdown from 'shared/components/ui/BrandDropdown';
import { displayName, nodeIds } from './graphModel';
import { kindOf } from './nodeKinds';

/**
 * Where an outcome leads: an existing step, a brand-new verdict, or a new
 * step inserted on that edge. Shared by the outcome list and the expression
 * editor so "go to" is the same control wherever the walk is pointed.
 */
export const NEW_PASS = '__new_pass__';
export const NEW_FAIL = '__new_fail__';
export const NEW_STEP = '__new_step__';

export default function TargetPicker({ graph, nodeId, value, onChange, ariaLabel, disabled = false, allowClear = false, className = 'w-[46%] min-w-[140px]' }) {
  const targets = nodeIds(graph).filter((id) => id !== nodeId);
  const items = targets.map((id) => {
    const k = kindOf(graph.nodes[id]);
    const suffix = k === 'verdict' ? (graph.nodes[id].config?.passed === false ? ' (fail)' : ' (pass)') : '';
    return { value: id, label: `${displayName(graph, id)}${suffix}` };
  });
  if (value && !targets.includes(value)) items.unshift({ value, label: `${value} (missing)` });

  return (
    <div className={className}>
      <BrandDropdown compact ariaLabel={ariaLabel} value={value ?? ''} disabled={disabled} onChange={onChange} menuMinWidth={240}
        placeholder="Not connected"
        options={[
          { groupLabel: 'Go to', options: allowClear ? [{ value: '', label: 'Not connected' }, ...items] : items },
          {
            groupLabel: 'New',
            options: [
              { value: NEW_PASS, label: '＋ New pass verdict' },
              { value: NEW_FAIL, label: '＋ New fail verdict' },
              { value: NEW_STEP, label: '＋ Insert a step here…' },
            ],
          },
        ]} />
    </div>
  );
}
